import { splitSeriesAt } from "./split-series.js";
import type { SeriesGet, SeriesSet } from "./types.js";

export async function resizeSeries(
  set: SeriesSet,
  get: SeriesGet,
  sourceId: string,
  occurrenceIso: string,
  newDurationMinutes: number,
): Promise<void> {
  await splitSeriesAt(set, get, sourceId, occurrenceIso, { duration_minutes: newDurationMinutes });
}
